import React, { useEffect, useState } from 'react';

interface UseDropdownPositionProps {
  isModalOpen: boolean;
  isMobile: boolean;
  buttonRef: React.RefObject<HTMLButtonElement>;
  maxDropdownHeight: number;
}

export const useDropdownPosition = ({
  isModalOpen,
  isMobile,
  buttonRef,
  maxDropdownHeight,
}: UseDropdownPositionProps) => {
  const [positionAbove, setPositionAbove] = useState(false);

  useEffect(() => {
    if (!isModalOpen || isMobile || !buttonRef?.current) return;

    const calculatePosition = () => {
      const buttonRect = buttonRef.current?.getBoundingClientRect();
      if (!buttonRect) return;

      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - buttonRect.bottom;
      const spaceAbove = buttonRect.top;

      if (spaceBelow < maxDropdownHeight && spaceAbove >= maxDropdownHeight) {
        setPositionAbove(true);
      } else {
        setPositionAbove(false);
      }
    };

    calculatePosition();

    window.addEventListener('resize', calculatePosition);
    window.addEventListener('scroll', calculatePosition, true);

    return () => {
      window.removeEventListener('resize', calculatePosition);
      window.removeEventListener('scroll', calculatePosition, true);
    };
  }, [isModalOpen, isMobile, buttonRef, maxDropdownHeight]);

  return positionAbove;
};

